import { Tab, TabPane, TabPaneProps, TabProps } from "semantic-ui-react";

export type BPTabProps = TabProps & {}

export function BPTab(props: BPTabProps) {
    return <Tab {...props}>
        {props.children}
    </Tab>;
}

type BPTabPaneProps = TabPaneProps & {}

export function BPTabPane(props: BPTabPaneProps) {
    return <TabPane {...props}>
        {props.children}
    </TabPane>;
}